module.exports = __webpack_public_path__ + "static/dungeon_delver-1a9fe200f43af0a7874cf7d9ff859821.jpg";